import { render, staticRenderFns } from "./ebs-links.component.vue?vue&type=template&id=bfed03d8&scoped=true&"
import script from "./ebs-links.component.vue?vue&type=script&lang=js&"
export * from "./ebs-links.component.vue?vue&type=script&lang=js&"
import style0 from "./ebs-links.component.vue?vue&type=style&index=0&id=bfed03d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfed03d8",
  null
  
)

export default component.exports